import { appEnvironment } from '../../../config'
// Publishable key based on country code
export function getStripeApiKey(countryCode) {
	if (countryCode === 'US') {
		if (appEnvironment === 'dev') {
			// Development US
			return 'pk_test_51PQpo4HS85HKTLmvqLt2vulCIZXcoQR5bwaahDQTLx2R4vuIs7xSSFwhXyRD8KEYG1cWDAjQa95h9WmI7ExceQaO00GyMPkFOL'
		}
		return 'pk_live_51PQpo4HS85HKTLmvIf32ybs8S6X0O2ouxabJ0jxXAAgwRkQtDxZZQteLYfWANphBlPnvre8Th3Dueyadl5qCufbV00HuuOZhhR'
	} else {
		if (appEnvironment === 'dev') {
			// Development europe
			return 'pk_test_51H7hO6AsGdm6jgYgmHc0nRDEb8xX8RGdoHO9C4RFyUwgE3Tu8fHjM7IunVZaLKLntHOunbfABUbisfKG08tp3W4Y00wRwGJNjN'
		}
		// Europe
		return 'pk_live_51H7hO6AsGdm6jgYg6kFhDzNXu4VoL66LuKBBO0wDwlMy7Z83NzDc64dNWlbgVu5jWhtg9o0aGpAo9CNatfbsPIfv00QGLVVIqF'
	}
}
